import React, { useState, useEffect } from "react";
import {TextField} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';
import useStyles from './styles'
import ttAPI from '../../api/ttAPI'


export default function SelectSite(props) {
  const { onFormUpdated, onSelect, selectedSite, labelName, disabled } = props
  const classes = useStyles();
  const [siteSearchedList, setSiteSearchedList] = useState([]);
  const [selectedSiteValue, setSelectedSiteValue] = useState({});
  const [siteInputValue, setSiteInputValue] = useState('');
  const [isSearchSiteOpen, setIsSearchSiteOpen] = useState(false);

  useEffect( () => {
    let mounted = true;
    async function fetchData() {
      const response = await ttAPI.getSitesByKey('', props.customerId);
      if(mounted){
          setSiteSearchedList(response);
      }
    }
    fetchData();
    return () => mounted = false;
  }, [props.customerId]);

  useEffect( () => {
    let mounted = true;
    async function fetchData() {
      const response = await ttAPI.getSitesByKey(
        siteInputValue === undefined || siteInputValue === null ? '' :
        siteInputValue, props.customerId);
      if(mounted){
          setSiteSearchedList(response);
      }
    }
    if (/*siteInputValue !== undefined && siteInputValue !== '' && */props.customerId > 0) {
      fetchData();
    }
    return () => mounted = false;
  }, [siteInputValue, props.customerId]);

  useEffect(() => {
    if (!isSearchSiteOpen) {
      setSiteSearchedList([]);
    }
  }, [isSearchSiteOpen]);

  useEffect(() => {
    if (selectedSite === undefined || selectedSite === null) {
      setSelectedSiteValue({});
      setSiteSearchedList([]);
      setSiteInputValue('');
    }
    else {
      setSelectedSiteValue(selectedSite);
      setSiteSearchedList([selectedSite]);
      setSiteInputValue(selectedSite.name);
      onSelect(selectedSite);
      onFormUpdated(true);
    }

  }, [selectedSite]);

   // note: for getOptionSelected: if you return false for no match then there will be a warning in the console complain the input does not match what's in the options}
  return (
<div className={classes.contentDiv}>
    {/*}<div>{`selectedSiteValue: ${selectedSiteValue !== undefined && selectedSiteValue !== null ? `'${selectedSiteValue.name}'` : 'null'}`}</div>
    <div>{`selected id: ${selectedSiteValue !== undefined && selectedSiteValue !== null ? `'${selectedSiteValue.id}'` : 'null'}`}</div>
    <div>{`siteInputValue: '${siteInputValue}'`}</div>*/}
    <div></div>


    <Autocomplete
      disabled={disabled ?? false}
      id="search-site"
      size="small"
      className={classes.autocomplete}
      getOptionSelected={(option, value) => {return Object.keys(option).length === 0 || Object.keys(value).length === 0 ? true : option.name === value.name;}}
      getOptionLabel={(option) => Object.keys(option).length === 0 ? '' : option.name}
      options={siteSearchedList}
      noOptionsText="Type to search"
      onChange={(event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          setSelectedSiteValue(newValue);
          props.onSelect(newValue);
          props.onFormUpdated(true);
        }
        else {
          props.onSelect(undefined);
          props.onFormUpdated(false);
        }
      }}
      open={isSearchSiteOpen}
      onOpen={() => {
        setIsSearchSiteOpen(true);
        if (siteSearchedList !== undefined && siteSearchedList !== null &&
            siteSearchedList.length === 0 && (siteInputValue === undefined ||
            siteInputValue !== null || siteInputValue === '')) {
            setSiteInputValue(' ');
        }
      }}
      onClose={() => {
        setIsSearchSiteOpen(false);
      }}
      inputValue={siteInputValue}
      value={selectedSiteValue}
      onInputChange={(event, newInputValue,reason) => {
          setSiteInputValue(newInputValue);
      }}

      renderInput={(params) => <TextField
                                {...params}
                                label={labelName}
                                variant="outlined"
                                  />}
      />
      </div>
  );
}
